import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AccessType } from "./AccessType";
import type { RolePermissionDTOBase } from "./RolePermissionDTOBase";
import type { RoleRef } from "./RoleRef";
import type { RoleStaff } from "./RoleStaff";
import type { ScopesRef } from "./ScopesRef";
import type { ScopesStaff } from "./ScopesStaff";

export class RolePermissionStaff implements RolePermissionDTOBase {
  constructor(public readonly rolePermissionId: number, public readonly roleId: RoleStaff | null, public readonly scopeId: ScopesStaff | null, public readonly accessType: AccessType, public readonly roleIdTargetIds: RoleRef, public readonly scopeIdTargetIds: ScopesRef) {
    this.cbiServiceContext = null;
    this.roleIdLoaded = this.roleId != null;
    this.roleIdCached = this.roleId;
    this.scopeIdLoaded = this.scopeId != null;
    this.scopeIdCached = this.scopeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private roleIdLoaded: boolean;
  private roleIdCached: RoleStaff | null;
  private scopeIdLoaded: boolean;
  private scopeIdCached: ScopesStaff | null;
  async roleIdLazy(): Promise<RoleStaff> {
    if (!this.roleIdLoaded) {
      this.roleIdCached = await this.cbiServiceContext!.permissionService().getRoleStaff(this.roleIdTargetIds.roleId);
      this.roleIdLoaded = true;
    }
    return this.roleIdCached!;
  }
  async scopeIdLazy(): Promise<ScopesStaff> {
    if (!this.scopeIdLoaded) {
      this.scopeIdCached = await this.cbiServiceContext!.permissionService().getScopesStaff(this.scopeIdTargetIds.scopeId);
      this.scopeIdLoaded = true;
    }
    return this.scopeIdCached!;
  }
}
